import React from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Avatar,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  useMediaQuery,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Computer } from "@mui/icons-material";
import { GlassDialog, dialogTransitionProps } from "../../../theme/theme";

export function SystemDialog({
  open,
  onClose,
  theme,
  darkMode,
  isEditMode,
  newSystem,
  setNewSystem,
  addSystem,
  editSystem,
}) {
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <GlassDialog open={open} onClose={onClose} maxWidth="sm" fullWidth fullScreen={fullScreen} {...dialogTransitionProps}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{ bgcolor: alpha(theme.palette.secondary.main, 0.1), width: 48, height: 48 }}>
            <Computer color="secondary" />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
              {isEditMode ? "Edit System" : "Add New System"}
            </Typography>
            <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary' }}>
              {isEditMode ? "Update system information" : "Register a new system"}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <TextField
          fullWidth
          label="System UID"
          margin="normal"
          value={newSystem.uuid}
          onChange={(e) => setNewSystem({ ...newSystem, uuid: e.target.value })}
          disabled={isEditMode}
          placeholder="Enter unique system identifier"
        />
        <TextField
          fullWidth
          label="Project ID"
          margin="normal"
          value={newSystem.project_id}
          onChange={(e) => setNewSystem({ ...newSystem, project_id: e.target.value })}
          placeholder="Enter project identifier"
        />
        <TextField
          fullWidth
          label="Software ID"
          margin="normal"
          value={newSystem.software_id}
          onChange={(e) => setNewSystem({ ...newSystem, software_id: e.target.value })}
          placeholder="Enter software identifier"
        />
        <FormControlLabel
          control={
            <Switch
              checked={newSystem.amc}
              onChange={(e) => setNewSystem({ ...newSystem, amc: e.target.checked })}
              color="primary"
            />
          }
          label={
            <Box sx={{ ml: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
                Annual Maintenance Contract
              </Typography>
              <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary' }}>
                Enable AMC for this system
              </Typography>
            </Box>
          }
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={isEditMode ? editSystem : addSystem}
          variant="contained"
          sx={{ px: 4 }}
        >
          {isEditMode ? "Update System" : "Add System"}
        </Button>
      </DialogActions>
    </GlassDialog>
  );
}

export default SystemDialog;
